module.exports = __webpack_public_path__ + "static/img/作品53.6042c66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品53.png
// module id = VALu
// module chunks = 1